import { useEffect, useRef } from "react";

// Ejecuta `callback` cada `intervalMs` mientras `paused` sea false.
// Guarda el callback en un ref para no reiniciar el intervalo en cada render.
const useAutoRefresh = (callback, intervalMs, paused) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => callbackRef.current(), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, paused]);
};

export default useAutoRefresh;
